
import React, { useState, useEffect, useRef } from "react";
// import Header from "../common/components/Header";
import { useNavigate } from "react-router-dom"; // Add this at the top
import "./Alliteams.css";
import Cateringpakagecart from "./Cateringpakagecart";

import { Link } from "react-router-dom";

import { FaCommentAlt, FaChevronDown, FaChevronUp } from "react-icons/fa";

import 'semantic-ui-css/semantic.min.css';
import SidescrollAdvertisements from './SidescrollAdvertisements';
import axios from 'axios';
import { FaUser, FaShoppingCart, FaCreditCard, FaList, FaHeart, FaMapMarkerAlt, FaBell, FaHeadset, FaCog } from "react-icons/fa";

import { useLocation } from 'react-router-dom';
// import Briyani from "../images/products/Briyani.jpg";
// import Staters from "../images/products/starters2.jpg";
// import Dosa from "../images/products/Dosa.jpg";
// import Meals from "../images/products/meals.jpg";
import logo from "../banner2.jpg";
import menu1 from "../menu1.jpg";

import allCartsImage from "../order-delivered.jpg"; // Adjust the path as needed

// import Biryanidata from './Biryanidata';
const Cartsdata = () => {

    const getOrderColor = (orderType) => {
        switch (orderType) {
            case "Dine-In":
                return "#1E90FF"; // Blue
            case "Take Away":
                return "#FF6347"; // Tomato
            case "Delivery":
                return "#20B2AA"; // LimeGreen
            default:
                return "#ccc"; // Grey
        }
    };
    // const [activeCategory, setActiveCategory] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [parentId, setParentId] = useState(null);
    const isMobile = window.innerWidth <= 768;
    // const [activeCategory, setActiveCategory] = useState("Allitems");
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    // const [quantities, setQuantities] = useState({});
    const [quantities, setQuantities] = useState({}); // Track quantities of items
    const [showPopup, setShowPopup] = useState(false);
    const [popupItem, setPopupItem] = useState(null);
    const [items, setItems] = useState([]); // Store API data
    // const [quantities, setQuantities] = useState({}); // Manage quantity state
    const [categories, setCategories] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const [dishes, setDishes] = useState([]);  // Added state for dishes
    const location = useLocation();
    const [posts, setPosts] = useState([]);
    // const [activeCategory, setActiveCategory] = useState("Allcarts");
    const navigate = useNavigate(); // Define navigate
    const [filteredItems, setFilteredItems] = useState([]);
    const [cartData, setCartData] = useState([]);
    // const [allCategories, setAllCategories] = useState(["Allcarts"]);
    // const [activeCategory, setActiveCategory] = useState("Allcarts");
    const [allCategories, setAllCategories] = useState(["Allcarts"]);
    const [activeCategory, setActiveCategory] = useState("Allcarts");
    // Fetch Cart Data
    // Fetch Cart Data
    const [selectedDishId, setSelectedDishId] = useState(null); // Store the selected dishId
    const [cartItems, setCartItems] = useState([]);
    const [selectedCartId, setSelectedCartId] = useState(null);
    const [refresh, setRefresh] = useState(false);  // ✅ Define refresh state
    const handleCategoryClick = (category) => {
        setActiveCategory(category);

        // Ensure React updates the state immediately
        setFilteredItems(prevItems => {
            if (category === "Allcarts") return cartData;
            return cartData.filter(item => item.dishName === category);
        });

        // 🔥 Force Re-Render Immediately
        setTimeout(() => setRefresh(prev => !prev), 0);
    };

    // ✅ Trigger re-fetch when `refresh` changes
    useEffect(() => {
        let selectedItems = activeCategory === "Allcarts"
            ? cartData
            : cartData.filter(item => item.dishName === activeCategory);

        setFilteredItems([...selectedItems]);
    }, [activeCategory, cartData, refresh]); // ✅ Added `refresh` to dependencies

    // ✅ Fetch data function (runs in the background)




    // ✅ Track when `selectedCartId` and `selectedDishId` become available
    useEffect(() => {
        if (!selectedCartId || !selectedDishId) {
            console.warn("⏳ Waiting for selectedCartId and selectedDishId to be set...");
            return;
        }
        console.log("✅ selectedCartId and selectedDishId are now available");
    }, [selectedCartId, selectedDishId]); // ✅ Runs when these values change




    useEffect(() => {
        const userId = localStorage.getItem("userId");

        if (!userId) {
            console.error("🚨 User ID not found in localStorage!");
            return;
        }

        const fetchCartData = () => {
            axios
                .get(` https://backend.maamaas.com/food/api/cart/${userId}/without-seating`)
                .then((response) => {
                    console.log("🛒 Cart Response:", response.data);

                    // ✅ handle if API returns array
                    const cartItems = Array.isArray(response.data)
                        ? response.data[0]?.cartItems || []
                        : response.data.cartItems || [];

                    setCartData(cartItems);

                    const categories = [...new Set(cartItems.map((item) => item.dishName))];
                    setAllCategories(["Allcarts", ...categories]);
                    setFilteredItems(cartItems);
                })
                .catch((error) => console.error("❌ Error fetching cart data:", error));
        };

        // Initial fetch
        fetchCartData();

        // Refresh every 10 seconds
        // const interval = setInterval(fetchCartData, 10000);

        // return () => clearInterval(interval);
    }, []);











    useEffect(() => {
        if (activeCategory === "Allcarts") {
            setFilteredItems(cartData); // ✅ Show all items
        } else {
            const filtered = cartData.filter(item => item.dishId === activeCategory);
            setFilteredItems(filtered);
        }
    }, [activeCategory, cartData]); // ✅ Depend on activeCategory and cartData


    // Static categories with "Allcarts"
    const staticCategories = ["Allcarts"];

    // Dynamic categories from API (Extract dish names)
    const dynamicCategories = [...new Set(cartData.map(item => item.dishName))];










    // const iconMap = {
    //     Allcarts: <FaShoppingCart />,
    //     Biryani: <img src={Briyani} alt="Briyani" style={{ width: '100px', height: '100px', borderRadius: '50%' }} />,
    //     Staters: <img src={Staters} alt="Staters" style={{ width: '100px', height: '100px', borderRadius: '50%' }} />,
    //     Dosa: <img src={Dosa} alt="Dosa" style={{ width: '100px', height: '100px', borderRadius: '50%' }} />,
    //     Meals: <img src={Meals} alt="Meals" style={{ width: '100px', height: '100px', borderRadius: '50%' }} />,

    // };


    const handleFilterClick = (type) => {
        if (type === "Veg") {
            setIsVegSelected(true);
            setIsNonVegSelected(false);
        } else if (type === "Non-veg") {
            setIsNonVegSelected(true);
            setIsVegSelected(false);
        } else {
            setIsVegSelected(false);
            setIsNonVegSelected(false);
        }
    };

    const currentCategoryItems = categories[activeCategory] || [];
    const addToCarts = (id) => {
        setQuantities((prev) => ({ ...prev, [id]: 1 })); // Set initial quantity to 1
        setPopupItem(filteredItems.find((item) => item.id === id)); // Store clicked item
        setShowPopup(true);
    };

    const increaseQuantity = (id) => {
        setQuantities((prev) => ({ ...prev, [id]: (prev[id] || 0) + 1 }));
    };

    const decreaseQuantity = (id) => {
        setQuantities((prev) => {
            const newQuantity = (prev[id] || 0) - 1;
            if (newQuantity <= 0) {
                const updatedQuantities = { ...prev };
                delete updatedQuantities[id]; // Remove item if quantity is 0
                return updatedQuantities;
            }
            return { ...prev, [id]: newQuantity };
        });
    };


    const scrollContainerRef = useRef(null);









    const getIconClassNames = (category) => {
        switch (category) {
            case "Allcarts":
                return "user";
            case "Biryani":
                return "shopping cart";
            case "Payments":
                return "credit card";
            case "Orders":
                return "list";
            case "Favorites":
                return "heart";
            case "Notifications":
                return "bell";
            case "Address":
                return "map marker alternate"
            case "Customer support":
                return "comments"
            case "Settings":
                return "settings"
            default:
                return "";
        }
    };

    const [bannerData, setBannerData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");




    const orderPosts = [
        { dishId: 1, orderType: " 🍕 Buy 1 Get 1 Free on Pizzas!" },
        { dishId: 2, orderType: "🍔 Flat 30% off on all Burgers this weekend!" },
        { dishId: 3, orderType: "🚚 Free Delivery on orders above ₹299!" },
        { dishId: 1, orderType: "🍕 Buy 1 Get 1 Free on Pizzas!" },
        { dishId: 2, orderType: "🚚 Free Delivery on orders above ₹299!" },
        { dishId: 3, orderType: "🧁 Dessert Combo just at ₹99 only today!" },
        { dishId: 1, orderType: "🍕 Buy 1 Get 1 Free on Pizzas!" },
        { dishId: 2, orderType: "🚚 Free Delivery on orders above ₹299!" },
        { dishId: 3, orderType: "🍔 Flat 30% off on all Burgers this weekend!", },
    ];

    const dishImages = {
        1: { image: logo },
        2: { image: menu1 },
        3: { image: logo },
    };


    const vendorId = localStorage.getItem("vendorId");

    useEffect(() => {
        if (!vendorId) return;

        const source = axios.CancelToken.source();

        (async () => {
            try {
                setLoading(true);

                const { data } = await axios.get(
                    ` https://backend.maamaas.com/food/banner/vendor/${vendorId}`,
                    { cancelToken: source.token }                 // ⬅️ no headers now
                );

                // 🔽 massage the fields once
                setBannerData({
                    ...data,
                    companyName: data.companyName || "No Name",

                });
                setError("");
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error(err);
                    setError("Could not load banner details.");
                }
            } finally {
                setLoading(false);
            }
        })();

        return () => source.cancel();
    }, [vendorId]);




    return (
        <>
            <div className="container-fluid">
                <div className="row" style={{ marginTop: "50px" }}>
                    <div className="col-lg-2 col-md-3 col-sm-3 col-3">
                        {/* 📌 Desktop View: Category Cards */}
                        <div
                            className="category-sidebar d-none d-sm-block mobile-scrolling-cart"  // Hide on mobile
                            style={{
                                maxHeight: "600px",
                                position: "sticky",
                                top: "0px",
                                marginTop: "5px",
                                // zIndex: 1000,
                                height: "100vh",
                                overflow: 'auto',
                                width: "180px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}
                        >
                            <div className="category-container" style={{
                                overflowY: "auto",
                                height: "556px",
                                marginTop: "68px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}>
                                {allCategories.map((category, index) => {
                                    const categoryImage =
                                        category === "Allcarts"
                                            ? allCartsImage
                                            : `data:image/png;base64,${cartData.find(item => item.dishName === category)?.dishImage || ""}`;

                                    return (
                                        <div
                                            key={index}
                                            className="category-card"
                                            onClick={() => handleCategoryClick(category)}
                                            style={{
                                                backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                                margin: "8px 0",
                                                padding: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                borderRadius: "15px",
                                                transition: "0.3s ease-in-out",
                                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                                height: "165px"
                                            }}
                                        >
                                            <img
                                                src={categoryImage}
                                                alt={category}
                                                style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    borderRadius: "50%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                            <div className="category-card-body d-flex justify-content-center p-0">
                                                <button
                                                    style={{
                                                        backgroundColor: activeCategory === category ? "#ddd" : "#fff", // Slight color change for active state
                                                        margin: "5px",
                                                        padding: "8px",
                                                        borderRadius: "10px",
                                                        cursor: "pointer",
                                                        transition: "0.3s ease-in-out",
                                                    }}

                                                >
                                                    {category}
                                                </button>
                                            </div>

                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* 📌 Mobile View: Dropdown */}


                    </div>
                    <div className="d-block d-sm-none " style={{ marginTop: "65px", width: "100%" }}>
                        <select
                            className="form-control "
                            onChange={(e) => handleCategoryClick(e.target.value)}
                            value={activeCategory}
                            style={{
                                padding: "8px",
                                borderRadius: "10px",
                                border: "1px solid #ccc",
                                width: "100%",
                                background: "#ee6521",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "20px"
                            }}
                        >
                            {allCategories.map((category, index) => (
                                <option key={index} value={category}>
                                    {category}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-lg-7 col-md-7 col-sm-12 col-12" >


                        <p className="breadcrumb maamaas-home-bredcums" style={{ marginTop: "40px", fontSize: "18px", marginLeft: "20px", marginBottom: "10px" }}>
                            <Link to="/" style={{ color: "purple", fontWeight: 'bold', textDecoration: "none" }}>Home</Link>
                            <span className="separator"> &gt; </span><span className="separator"> &gt; </span>
                            <Link
                                to="/Newmenuiteam"
                                style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                            >
                                {(bannerData?.companyName || "MAAMAAS")
                                    .charAt(0).toUpperCase() + (bannerData?.companyName || "MAAMAAS").slice(1).toLowerCase()}
                            </Link>

                            <span className="separator"> &gt; </span><span className="separator"> &gt; </span>
                            <Link to="" style={{ color: "purple", fontWeight: 'bold', textDecoration: "none" }}>Cart</Link>
                        </p>

                        <div className="cartsizes"
                            style={{
                                marginTop: "28px",
                                height:'650px',
                                overflow:'auto',
                                scrollbarWidth:'none',
                                padding: "20px",
                                borderRadius: "8px",
                            }}
                        >
                            {/* ✅ Show Ordercart Component When a Category is Clicked */}
                            {/* {filteredItems.length > 0 && ( */}
                            <Cateringpakagecart key={activeCategory} filteredDataProp={filteredItems} />



                        </div>
                        <div
                            className="col-lg-3"
                            style={{ display: isMobile ? "none" : "block" }}
                        >
                            <SidescrollAdvertisements />
                        </div>



                    </div>


                </div>



            </div>
        </>
    );
};

export default Cartsdata;

